document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pbi-toggle]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var content = this.nextElementSibling;
      if (!content) return;
      this.setAttribute('aria-expanded', String(!expanded));
      if (expanded) {
        content.classList.remove('pbi__content--open');
      } else {
        content.classList.add('pbi__content--open');
      }
    });
  });
});
